import * as main from "../cjs/main.js";
export default main;
export const generateBBAN = main.generateBBAN;
export const generateIBAN = main.generateIBAN;
export const isValidAccountNumberBLZ = main.isValidAccountNumberBLZ;
export const isValidBBAN = main.isValidBBAN;
export const isValidIBAN = main.isValidIBAN;